exports.crossChannelEndpoint = (state, params) => `${state.config.apiUrl}/v1/entity/${params.entityId}/cross-channel`;



// WEBPACK FOOTER //
// ./src/services/crossChannel/selectors.js